import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { Text } from '@atlaskit/primitives/compiled';
import Image from '@atlaskit/image';
import { token } from '@atlaskit/tokens';

import type { IssueTypeGroupHeader$key } from './__generated__/IssueTypeGroupHeader.graphql';

export type Props = {
	issueTypeGroupHeader: IssueTypeGroupHeader$key | null;
};

export const IssueTypeGroupHeader = ({ issueTypeGroupHeader }: Props) => {
	const data = useFragment<IssueTypeGroupHeader$key>(
		graphql`
			fragment IssueTypeGroupHeader on JiraJqlIssueTypeFieldValue {
				issueTypes {
					name
					avatar {
						small
					}
				}
			}
		`,
		issueTypeGroupHeader,
	);

	const issueType = data?.issueTypes[0]; // note: we are expecting only one issue type per group

	return (
		<>
			{issueType?.avatar?.small && (
				<Image
					height={token('space.200')}
					width={token('space.200')}
					src={issueType.avatar.small}
					alt={issueType.name}
				/>
			)}
			<Text>{issueType?.name}</Text>
		</>
	);
};
